import { connect } from 'react-redux';
import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";

import AISettings from './dashboard/AISettings';
import WeeklyContextInput from './onboarding/WeeklyContextInput';

const WeeklyContextPage = ({ auth }) => {
    const [platform_league_id, setPlatform_league_id] = useState(null);
    const [isInitializing, setIsInitializing] = useState(true);

    const loadPlatformLeagueId = useCallback(async () => {
        try {
            if (auth?.user?.id) {
                const response = await axios.get('/api/get/user-league-data');
                if (response.data.success) {
                    setPlatform_league_id(response.data.platform_league_id);
                }
            }
        } catch (error) {
            console.error('Error loading platform league id:', error);
        }
    }, [auth?.user?.id]);

    useEffect(() => {
        // Load platform_league_id
        loadPlatformLeagueId();
        
        // Mark initialization as complete
        setIsInitializing(false);
    }, [loadPlatformLeagueId]);

    // Show loading state while initializing
    if (isInitializing) {
        return (
            <div className="pt-5 weekly-context-section">    
                <Row className="weekly-context-header">
                    <Col xs={1} md={2}></Col>
                    <Col xs={10} md={8}>       
                        <Row className="text-center weekly-context-title-row">
                            <Col className="weekly-context-title">Loading Weekly Context</Col>
                        </Row>

                        <Row className="pt-4">
                            <Col>
                                <div className="text-center">
                                    <Spinner animation="border" role="status" className="mb-3">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                    <h4 className="text-white">Processing...</h4>
                                </div>
                            </Col>
                        </Row>                        
                    </Col>                            
                </Row>
            </div>
        );
    }

    return (
        <>
            <div className="dashboard-container">
                <Container fluid className="px-4">
                    {/* AI Settings */}
                    <Row className="mt-5 mb-2">
                        <Col>
                            <AISettings 
                                auth={auth} 
                                platform_league_id={platform_league_id} 
                            />
                        </Col>
                    </Row>

                    {/* Weekly Context Form */}
                    <Row className="mb-4">
                        <Col xs={1} md={2}></Col>
                        <Col xs={10} md={8}>       
                            <WeeklyContextInput 
                                showDropdown={true}
                                auth={auth}
                            />
                        </Col>                            
                    </Row>
                </Container>
            </div>
        </>
    );
};

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps)(WeeklyContextPage);
